import React from 'react';

interface WindowBodyProps {
  children: React.ReactNode;
  noPadding?: boolean;
}

const WindowBody: React.FC<WindowBodyProps> = ({ children, noPadding = false }) => {
  return (
    <div className={`window-body ${noPadding ? 'no-padding' : ''}`}>
      {children}
    </div>
  );
};

export default WindowBody;
